// extracted by mini-css-extract-plugin
module.exports = {"Output":"Output_Output__zzrxc"};